import {RESTRICTED_PARAM_NAMES} from 'shared';

export const getRestrictedParamNames = () => RESTRICTED_PARAM_NAMES;
